
import { defineComponent, reactive, provide, ref } from "vue";
import { User, Key } from "@element-plus/icons-vue";
import type { FormInstance, FormRules } from "element-plus";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

 //components
 import DialogPassReset from "./DialogPassReset.vue"

export default defineComponent({
    name: "sign-in",
    components:{DialogPassReset},
    setup() {
        const store = useStore();
        const router = useRouter();
        const version = ref(process.env.VUE_APP_VERSION)
        const terms = ref(process.env.VUE_APP_TERMS)
        const open_modal_passreset = ref(false)
        const ruleFormRef = ref < FormInstance > ();

        //provides
        provide ('open_modal_passreset', open_modal_passreset)

        const form = reactive({
            username: "",
            password: "",
        });

        const rules = reactive < FormRules > ({
            username: [{
                required: true,
                message: "Ingrese nombre de usuario",
                trigger: ["blur", "change"],
            }, ],
            password: [{
                required: true,
                message: "Ingrese contraseña",
                trigger: ["blur", "change"],
            }, ],
        });

        const submitButton = ref < HTMLButtonElement | null > (null);

        //Form submit function
        const onSubmitLogin = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;

            await formEl.validate((valid, fields) => {
                if (valid) onLogin();
            });
        };

        const onLogin = async () => {
            if (submitButton.value) {
                submitButton.value!.disabled = true;
                // Activate indicator
                submitButton.value.setAttribute("data-kt-indicator", "on");
            }

            // Clear existing errors
            store.dispatch(Actions.LOGOUT);

            // Send login request
            await store.dispatch(Actions.LOGIN, form);
            const [errorName] = Object.keys(store.getters.getErrors);
            const error = store.getters.getErrors[errorName];
            //console.log(store.getters.currentUser.redirect)

            if (!error) {
                const redirect = store.getters.currentUser.redirect;
                Swal.fire({
                    text: "Bienvenido a la plataforma virtual de mesa de partes!",
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Ir al panel!",
                    customClass: {
                        confirmButton: "btn fw-bold btn-light-primary",
                    },
                }).then(function () {
                    // Go to page after successfully login
                    router.push({
                        name: redirect,
                    });
                });
            } else {
                Swal.fire({
                    text: error,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Intentar otra vez!",
                    customClass: {
                        confirmButton: "btn fw-bold btn-light-danger",
                    },
                });
            }

            //Deactivate indicator
            submitButton.value ?.removeAttribute("data-kt-indicator");
            submitButton.value!.disabled = false;
        };

        return {
            version,
            terms,
            User,
            Key,
            ruleFormRef,
            form,
            rules,
            onSubmitLogin,
            submitButton,
            open_modal_passreset
        };
    },
});
